export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {children, className} = self.get();

    return h('div', {
        'ev-mousedown': function() {try {return (self._dragStart )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (children )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({'k-drag': true, [className]: className} )} catch(e) {_e(e)}}.call($this)))
}